module.exports = __webpack_public_path__ + "static/4-923ede5c2d4c7794c59bae0d7b3652de.jpg";